import { postNFLEvents } from './api'

// Anonymous usage tracking — which tabs, tiles, tools and Play Lab picks people actually use, so
// we cut and polish by data instead of guessing. Privacy: a random device id generated here (no
// name, email, access code or IP is sent), honours the browser's Do Not Track, and batches events
// (flushed every 8s, at 20 events, or when the page is hidden). Never throws.
const KEY = 'brkr_dev'
let queue = []
let timer = null
let week = 0

function deviceId() {
  try {
    let id = localStorage.getItem(KEY)
    if (!id) {
      id = (crypto?.randomUUID ? crypto.randomUUID() : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`)
      localStorage.setItem(KEY, id)
    }
    return id
  } catch (_) { return '' }
}

const dnt = () => { try { return navigator.doNotTrack === '1' || window.doNotTrack === '1' } catch (_) { return false } }

function flush() {
  if (timer) { clearTimeout(timer); timer = null }
  if (!queue.length) return
  const events = queue.splice(0, 25)
  const device = deviceId()
  if (device) postNFLEvents({ device, week, events })
  if (queue.length) flush()
}

export function setTrackWeek(w) { week = w || 0 }

// event: lowercase name (view, tile, playlab_generate…); target: what was chosen.
export function track(event, target = '') {
  try {
    if (dnt() || !event) return
    queue.push({ event, target: String(target ?? '').slice(0, 80) })
    if (queue.length >= 20) return flush()
    if (!timer) timer = setTimeout(flush, 8000)
  } catch (_) {}
}

try {
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') flush() })
} catch (_) {}
